import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RootState } from '../../../shared/redux/reducers/index';
import styles from './edit-unit-type.module.scss';
import { format } from 'timeago.js';

import { ErrorInfo, isErrorInfo } from '../../../shared/interfaces/error-info.interface';
import { trackPage } from '../../../shared/services/utils/tracking/tracking.service';
import { UnitTypeUiModel } from '../../../shared/ui-models/unit-type.ui-model';
import { ManagerInfo } from './components/manager-info/manager-info.container';
import { AssignManagerModal } from './components/assign-Manager-modal/assign-manager-modal.component';
import { PropertyUiManagersListModel } from '../../../shared/ui-models/propertyManager.ui.model';

import {
  updateUnitTypeData,
  uploadUnitTypeShowRoomImage,
  deleteUnitTypeShowroomImage,
  uploadUnitTypeImage,
  deleteUnitTypeImage,
  searchPayouts,
  syncUnitTypeChannel,
  deleteBrandingImage,
  uploadBrandingImage,
  addPropertyManagerToUnits,
  deletePropertyManagerToUnits
} from '../../shared/services/data.service';

import { RouteComponentProps } from 'react-router';
import EditGeneralInfo from './components/edit-general-info/edit-general-info.container';
import {
  getAllTypeOfUnit,
  getAllUnitTypeGroups,
  getAllUnitViews,
  getAllAmenities,
  getAllBuilding
} from '../../../shared/services/data/lookups.data';
import { getModuleName } from '../../shared/services/unit-type.service';
import { AmenityUiModel } from '../../../shared/ui-models/amenity.ui-model';
import SelectAmenities from './components/select-amenities/select-amenities.container';
import { PUBLIC_PATH } from '../../../shared/config/routes-config';
import { getUnitTypeDetails } from '../../../shared/services/data/unit-type.data';
import EditFinancialInfo from './components/edit-financial-info/edit-financial-info.container';
import { ReservationMode } from '../../../shared/enums/reservation-mode.enum';
import EditVisuals from './components/edit-visuals/edit-visuals.container';
import { ImageListType, ImageType } from 'react-images-uploading';
import Rooms from './components/rooms/rooms.container';
import EditPlanInfo from './components/edit-plans-info/edit-plan-info.container';
import { UnitTypeGroupUiModel } from '../../../shared/ui-models/unit-type-group.ui-model';
import { Tabs, TabsPosition } from '../../../shared/components/group-ui/tabs/tabs.component';
import { Payout, SearchPayOutDto } from '../../../shared/models/payout.model';
import { LandLordInfo } from './components/landlord-info/landlord-info.container';
import { AssignLandlordModal } from '../unit-types-list/components/assign-landlord-modal/assign-landlord-modal.component';
import { CustomPrice } from './components/custom-price/custom-price.container';
import { StayDuration } from './components/stay-duration/stay-duration.component';
import { CustomPriceModel } from '../../../shared/models/unit-types.model';
import { BookingMode } from '../../../shared/enums/booking-mode.enum';
import { AssignPartnerModal } from '../unit-types-list/components/assign-partner-modal/assign-partner-modal.component';
import { PartnerInfo } from './components/partner-info/partner-info.container';
import BrandingDetails from './components/BrandingDetails';
import { AccountManagerInfo } from './components/accountManager-info/account-manager-info.container';
import { ConfirmModal } from './components/confirm-modal/confirm-modal.component';
import moment from 'moment';
import { EditGeneralInfoArabic } from './components/edit-general-info/edit-general-info-ar.container';
import { birdToast } from '../../../shared/components/core-ui/toast';
import { LoadingData } from '../../../ui/LoadingData';
import {
  BirdhouseIcon,
  BoltIcon,
  CalendarIcon,
  CloudSyncIcon,
  CorrectIcon,
  EyeIcon,
  EyeOffIcon,
  LinkCopyIcon,
  LinkIcon,
  LocationIcon,
  ManageIcon,
  ResetIcon,
  UnlinkIcon
} from '../../../ui/Icons';
import Tooltip from '../../../ui/Tooltip';
import { UserRole } from '../../../shared/enums/user-role.enum';
import { hasRole } from '../../../shared/services/helpers/auth-helper/auth-helper.service';

export const EditUnitType: React.FC<
  RouteComponentProps<{
    id: string;
  }> & {
    userRole?: UserRole;
    userRoles?: UserRole[];
  }
> = ({ match, userRole, userRoles }) => {
  const [unitType, setUnitType] = useState<UnitTypeUiModel>();
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [syncingChannelData, setSyncingChannelData] = useState<boolean>(false);
  const [loadingAmenities, setLoadingAmenities] = useState<boolean>(false);
  const [amenitiesList, setAmenitiesList] = useState<AmenityUiModel[]>();
  const [unitTypeGroupsList, setUnitTypeGroupsList] = useState<UnitTypeGroupUiModel[]>([]);
  const [unitTypeViewsList, setUnitTypeViewsList] = useState<
    {
      id?: string;
      name: string;
    }[]
  >([]);
  const [typeOfUnitList, setTypeOfUnitList] = useState<
    {
      id?: string;
      name: string;
    }[]
  >([]);
  const [buildingList, setBuildingList] = useState<any[]>([]);
  const [isCopy, setIsCopy] = useState(false);
  const [tabKey, setTabKey] = useState('General');
  const [payouts, setPayouts] = useState<Payout[]>([]);
  const [disabledListSwitcher, setDisabledListSwitcher] = useState<boolean>(false);
  const { t } = useTranslation();
  const [showAssignUserModal, setShowAssignUserModal] = useState<boolean>(false);
  const [payoutstoUpdate, setPayoutstoUpdate] = useState<string[]>();
  const [showAssignPartnerModal, setShowAssignPartnerModal] = useState<boolean>(false);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [showAssignManagerModal, setShowAssignManagerModal] = useState<boolean>(false);
  const [showUnsyncedModal, setShowUnsyncedModal] = useState<boolean>(false);
  const canEditUnitType = hasRole([
    UserRole.E_COMMERCE,
    UserRole.ECOMMERCE_SPECIALIST,
    UserRole.ECOMMERCE_SENIOR_SPECIALIST,
    UserRole.ADMIN,
    UserRole.SUPER_ADMIN
  ]);

  const ensureCanEdit = () => {
    if (!canEditUnitType) {
      birdToast.error('You do not have permission to edit Unit Types.');
      return false;
    }

    return true;
  };

  const formatTimestamp = (timestamp?: number | string) => {
    if (!timestamp) {
      return '-';
    }

    const parsed = moment(timestamp);

    if (!parsed.isValid()) {
      return '-';
    }

    return parsed.format('DD MMM YYYY, HH:mm');
  };

  const fetchAmenitiesData = useCallback(() => {
    setLoadingAmenities(true);
    getAllAmenities(getModuleName()).then((response: AmenityUiModel[] | ErrorInfo) => {
      setLoadingAmenities(false);
      if (!isErrorInfo(response)) {
        setAmenitiesList(response);
      }
    });
  }, []);

  const searchPayout = useCallback((searchPayoutData: SearchPayOutDto) => {
    searchPayouts(searchPayoutData).then((response) => {
      if (!isErrorInfo(response)) {
        setPayouts(response);
      }
    });
  }, []);

  const getUnitDetails = useCallback(
    (unitTypeIdValue: string, moduleName: string): void => {
      getUnitTypeDetails(unitTypeIdValue, moduleName).then(
        (response: UnitTypeUiModel | ErrorInfo) => {
          setLoadingData(false);
          if (!isErrorInfo(response)) {
            setUnitType(response);
            fetchAmenitiesData();
            searchPayout({ unitTypeId: Number(response?.id) || 0 });
            // getExpenses({ unitTypeId: Number(response?.id) }).then((response) => {
            //   if (!isErrorInfo(response)) {
            //     setExpenses(response);
            //   }
            // });
          } else {
            birdToast.error(response.errorMessage);
          }
        }
      );
    },
    [fetchAmenitiesData, searchPayout]
  );
  const addPropertyManagement = (show: boolean) => {
    if (!ensureCanEdit()) return;
    setShowAssignManagerModal(show);
  };

  const handleAddPropertyManager = (id: string) => {
    if (!ensureCanEdit()) return;
    console.log(id, unitType?.id || '');
    addPropertyManagerToUnits(id, Number(unitType?.id)).then(
      (response: UnitTypeUiModel | ErrorInfo) => {
        if (!isErrorInfo(response)) {
          birdToast.success(
            t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.NOTIFICATIONS.UPDATE_PROPERTY.MESSAGE')
          );
          setUnitType({ ...unitType, propertyManagersList: response.propertyManagersList });
        } else {
          birdToast.error(
            t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.NOTIFICATIONS.UPDATE_FAILED.TITLE')
          );
        }
      }
    );
  };

  const handleDeletePropertyManager = (id: string) => {
    if (!ensureCanEdit()) return;
    console.log(id, unitType?.id || '');
    deletePropertyManagerToUnits(id, Number(unitType?.id)).then(
      (response: UnitTypeUiModel | ErrorInfo) => {
        if (!isErrorInfo(response)) {
          birdToast.success(
            t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.NOTIFICATIONS.UPDATE_PROPERTY.MESSAGE')
          );
          setUnitType({ ...unitType, propertyManagersList: response.propertyManagersList });
        } else {
          birdToast.error(
            t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.NOTIFICATIONS.UPDATE_FAILED.TITLE')
          );
        }
      }
    );
  };

  const handleChannelManagerSync = () => {
    if (!ensureCanEdit()) return;
    if (unitType && unitType.id) {
      setSyncingChannelData(true);
      syncUnitTypeChannel(unitType.id).then((response: UnitTypeUiModel | ErrorInfo) => {
        setSyncingChannelData(false);
        if (!isErrorInfo(response)) {
          birdToast.success('Unit Type synced with Channel Manager Successfully');
        } else {
          birdToast.error('Unit Type failed to sync with Channel Manager. Please contact support');
        }
      });
    }
  };

  const handleUpdateUnitType = (data: Partial<UnitTypeUiModel>) => {
    if (!ensureCanEdit()) return;
    if (unitType && unitType.id) {
      setDisabledListSwitcher(true);
      setSyncingChannelData(true);
      const promise = updateUnitTypeData(unitType.id, data).then(
        (response: UnitTypeUiModel | ErrorInfo) => {
          setDisabledListSwitcher(false);
          setSyncingChannelData(false);
          if (!isErrorInfo(response)) {
            setUnitType({
              ...unitType,
              name: response.name,
              description: response.description,
              maxGuests: response.maxGuests,
              unitMeters: response.unitMeters,
              bedrooms: response.bedrooms,
              bathrooms: response.bathrooms,
              unitTypeLink: response.unitTypeLink,
              viewLink: response.viewLink,
              isListed: response.isListed,
              isManaged: response.isManaged,
              bookingMode: response.bookingMode,
              amenities: response.amenities,
              houseRules: response.houseRules,
              ratePlans: response.ratePlans,
              fees: response.fees,
              onboardingMessage: response.onboardingMessage,
              landlordId: response.landlordId,
              landlordEmail: response.landlordEmail,
              landlordPhone: response.landlordPhone,
              landlordUsername: response.landlordUsername,
              landlordShare: response.landlordShare,
              partnerId: response.partnerId,
              partnerEmail: response.partnerEmail,
              partnerPhone: response.partnerPhone,
              partnerUsername: response.partnerUsername,
              partnerShare: response.partnerShare,
              roomTypePhotos: response.roomTypePhotos,
              customPrices: response.customPrices,
              beds: response.beds,
              cmId: response.cmId,
              cmLastModifiedAt: response.cmLastModifiedAt,
              cmLastModifiedByUsername: response.cmLastModifiedByUsername,
              cmLastModifiedById: response.cmLastModifiedById,
              unitPrice: response?.unitPrice,
              minStayDuration: response?.minStayDuration,
              maxStayDuration: response?.maxStayDuration,
              downPayment: response?.downPayment,
              insurance: response?.insurance,
              reservationMode: response?.reservationMode,
              ...response
            });
          } else {
            throw response;
          }
        }
      );
      birdToast.promise(promise, {
        loadingMessage: 'Update in progress...',
        successMessage: 'Unit Type updated successfully',
        errorFailedMessage: 'Failed to update Unit Type',
        errorPermissionMessage: 'You do not have permission to update Unit Type'
      });
    }
  };

  const handleUpdateImageOrder = (data: Partial<UnitTypeUiModel>) => {
    if (!ensureCanEdit()) return;
    if (unitType && unitType.id) {
      setDisabledListSwitcher(true);
      setSyncingChannelData(true);
      const promise = updateUnitTypeData(unitType.id, data).then(
        (response: UnitTypeUiModel | ErrorInfo) => {
          setDisabledListSwitcher(false);
          setSyncingChannelData(false);
          if (!isErrorInfo(response)) {
            setUnitType({
              ...unitType,
              ...response
            });
          } else {
            throw response;
          }
        }
      );
      birdToast.promise(promise, {
        loadingMessage: 'Updating image order...',
        successMessage: 'Image order updated successfully',
        errorFailedMessage: 'Failed to update image order',
        errorPermissionMessage: 'You do not have permission to update image order'
      });
    }
  };

  const uploadShowRoomImageHandler = (roomName: string, images: ImageListType) => {
    if (!ensureCanEdit()) return;
    if (unitType && unitType.id && images.length > 0 && images) {
      uploadUnitTypeShowRoomImage(roomName, handleImageData(images), unitType.id).then(
        (response: UnitTypeUiModel | ErrorInfo) => {
          if (!isErrorInfo(response)) {
            birdToast.success(
              t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.NOTIFICATIONS.UPDATE_PROPERTY.MESSAGE')
            );
            setUnitType({
              ...unitType,
              showRooms: response.showRooms
            });
          } else {
            birdToast.error(
              t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.NOTIFICATIONS.UPDATE_FAILED.TITLE')
            );
          }
        }
      );
    }
  };
  const handleImageData = (images: ImageListType) => {
    const imagesList: FileList[] = [];
    images.map((image: ImageType) => image.file && imagesList.push(image?.file));
    return imagesList;
  };
  const uploadImageHandler = (images: ImageListType) => {
    if (!ensureCanEdit()) return;
    if (unitType && unitType.id && images.length > 0 && images) {
      setSyncingChannelData(true);
      uploadUnitTypeImage(handleImageData(images), unitType.id).then(
        (response: UnitTypeUiModel | ErrorInfo) => {
          setSyncingChannelData(false);
          if (!isErrorInfo(response)) {
            birdToast.success(
              t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.NOTIFICATIONS.UPDATE_PROPERTY.MESSAGE')
            );
            setUnitType({
              ...unitType,
              roomTypePhotos: response.roomTypePhotos,
              cmId: response.cmId,
              cmLastModifiedAt: response.cmLastModifiedAt,
              cmLastModifiedByUsername: response.cmLastModifiedByUsername,
              cmLastModifiedById: response.cmLastModifiedById
            });
          } else {
            birdToast.error(
              t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.NOTIFICATIONS.UPDATE_FAILED.TITLE')
            );
          }
        }
      );
    }
  };

  const handleDeleteShowroomImageHandler = (imageId: string, roomId: string) => {
    if (!ensureCanEdit()) return;
    if (unitType && unitType.id) {
      deleteUnitTypeShowroomImage(unitType.id, imageId, roomId).then(
        (response: UnitTypeUiModel | ErrorInfo) => {
          if (!isErrorInfo(response)) {
            birdToast.success(
              t('UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.NOTIFICATIONS.UPDATE_UNIT_TYPE.MESSAGE')
            );
            setUnitType({
              ...unitType,
              showRooms: response.showRooms
            });
          } else {
            birdToast.error(
              t('UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.NOTIFICATIONS.UPDATE_FAILED.TITLE')
            );
          }
        }
      );
    }
  };
  const handleDeleteImageHandler = (imageId: string) => {
    if (!ensureCanEdit()) return;
    if (unitType && unitType.id) {
      setSyncingChannelData(true);
      deleteUnitTypeImage(unitType.id, imageId).then((response: UnitTypeUiModel | ErrorInfo) => {
        setSyncingChannelData(false);
        if (!isErrorInfo(response)) {
          birdToast.success(
            t('UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.NOTIFICATIONS.UPDATE_UNIT_TYPE.MESSAGE')
          );
          setUnitType({
            ...unitType,
            roomTypePhotos: response.roomTypePhotos,
            cmId: response.cmId,
            cmLastModifiedAt: response.cmLastModifiedAt,
            cmLastModifiedByUsername: response.cmLastModifiedByUsername,
            cmLastModifiedById: response.cmLastModifiedById
          });
        } else {
          birdToast.error(
            t('UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.NOTIFICATIONS.UPDATE_FAILED.TITLE')
          );
        }
      });
    }
  };
  const addLandLord = (payoutsToUpdate: string[]) => {
    if (!ensureCanEdit()) return;
    setShowAssignUserModal(true);
    setPayoutstoUpdate(payoutsToUpdate);
  };
  const deleteLandLord = () =>
    handleUpdateUnitType({ landlordId: '', landlordShare: 0, landlordUsername: '' });

  const addPartner = () => {
    if (!ensureCanEdit()) return;
    setShowAssignPartnerModal(true);
  };
  const deletePartner = () => {
    handleUpdateUnitType({ partnerId: '', partnerShare: 0, partnerUsername: '' });
  };

  const handleDeleteBrandingImageClick = (imageId: string) => {
    if (!ensureCanEdit()) return;
    if (unitType?.id) {
      setSyncingChannelData(true);
      deleteBrandingImage(unitType.id, imageId).then((response: UnitTypeUiModel | ErrorInfo) => {
        setSyncingChannelData(false);
        if (!isErrorInfo(response)) {
          getUnitDetails(String(unitType.id), getModuleName());

          birdToast.success(
            t('UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.NOTIFICATIONS.UPDATE_UNIT_TYPE.MESSAGE')
          );
          setUnitType({
            ...unitType,
            roomTypePhotos: response.roomTypePhotos,
            cmId: response.cmId,
            cmLastModifiedAt: response.cmLastModifiedAt,
            cmLastModifiedByUsername: response.cmLastModifiedByUsername,
            cmLastModifiedById: response.cmLastModifiedById
          });
        } else {
          birdToast.error(
            t('UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.NOTIFICATIONS.UPDATE_FAILED.TITLE')
          );
        }
      });
    }
  };

  const handleUploadBrandingImageClick = (file: File, brandingImageIndex: number) => {
    if (!ensureCanEdit()) return;
    if (unitType?.id && file) {
      setSyncingChannelData(true);
      uploadBrandingImage(file, unitType.id, brandingImageIndex).then(
        (response: UnitTypeUiModel | ErrorInfo) => {
          setSyncingChannelData(false);
          if (!isErrorInfo(response)) {
            getUnitDetails(String(unitType.id), getModuleName());
            birdToast.success(
              t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.NOTIFICATIONS.UPDATE_PROPERTY.MESSAGE')
            );
            setUnitType({
              ...unitType,
              roomTypePhotos: response.roomTypePhotos,
              cmId: response.cmId,
              cmLastModifiedAt: response.cmLastModifiedAt,
              cmLastModifiedByUsername: response.cmLastModifiedByUsername,
              cmLastModifiedById: response.cmLastModifiedById
            });
          } else {
            birdToast.error(
              t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.NOTIFICATIONS.UPDATE_FAILED.TITLE')
            );
          }
        }
      );
    }
  };

  useEffect(() => {
    trackPage('edit-unitType');
    birdToast.info(
      'Important: If you update translatable content in General or Content, also update Listing Ar.'
    );
    setTabKey('General');

    setLoadingData(true);
    getAllUnitTypeGroups(getModuleName()).then((response: UnitTypeGroupUiModel[] | ErrorInfo) => {
      if (!isErrorInfo(response)) setUnitTypeGroupsList(response);
    });

    getAllUnitViews(getModuleName()).then((response) => {
      if (!isErrorInfo(response)) setUnitTypeViewsList(response);
    });
    getAllTypeOfUnit(getModuleName()).then((response) => {
      if (!isErrorInfo(response)) setTypeOfUnitList(response);
    });

    getAllBuilding(getModuleName()).then((response: any[] | ErrorInfo) => {
      if (!isErrorInfo(response)) setBuildingList(response);
    });

    getUnitDetails(match.params.id, getModuleName());
  }, []);

  if (showLoader || loadingData) return <LoadingData />;

  return (
    <>
      <div className="flex items-start justify-start flex-col h-full md:min-h-[calc(100vh-45px)] md:items-start bg-creams-100/20 md:pt-12 md:px-8 md:pb-24">
        <div className="border-b border-gray-200 w-full block pb-4 mb-4">
          <div className="flex flex-row gap-3 flex-wrap items-center pl-4 pt-4 md:pl-0 md:pt-0">
            <h1 className="text-2xl font-bold text-gray-800 m-0 whitespace-nowrap font-gilroy-medium cursor-help">
              {unitType?.name || 'Unit Type Name'}
            </h1>
            <div className="flex items-center gap-3 flex-wrap text-sm text-gray-600">
              {unitType?.area && (
                <>
                  <span className="text-gray-300">·</span>
                  <Tooltip title="Area">
                    <span className="flex items-center gap-1">
                      <LocationIcon size="18px" />
                      <span className="text-xl font-gilroy-medium">{unitType?.area}</span>
                    </span>
                  </Tooltip>
                </>
              )}
              {unitType?.propertyName && (
                <Tooltip title="Property">
                  <a
                    href={`${process.env.PUBLIC_URL}/properties/edit/${unitType?.propertyId}`}
                    className="cursor-pointer"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="flex items-center gap-1">
                      <BirdhouseIcon size="18px" />
                      <span className="text-xl font-gilroy-medium">{unitType?.propertyName}</span>
                    </span>
                  </a>
                </Tooltip>
              )}
            </div>
            <Tooltip title={'Open Link'}>
              <a href={`https://${unitType?.urlLink}`} target="_blank" rel="noopener noreferrer">
                <button
                  type="button"
                  className="flex items-center justify-center size-7 rounded-md border border-gray-200 bg-gray-50 hover:bg-blue-50 hover:border-blue-300 text-gray-400 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  <LinkIcon />
                </button>
              </a>
            </Tooltip>

            <Tooltip title={isCopy ? 'Copied!' : 'Copy link'}>
              <button
                type="button"
                className="flex items-center justify-center size-7 rounded-md border border-gray-200 bg-gray-50 hover:bg-blue-50 hover:border-blue-300 text-gray-400 hover:text-blue-600 transition-colors cursor-pointer"
                onClick={() => {
                  navigator.clipboard.writeText(`${unitType?.urlLink}`), setIsCopy(!isCopy);
                  setTimeout(() => setIsCopy(false), 2000);
                }}
              >
                {isCopy ? <CorrectIcon /> : <LinkCopyIcon />}
              </button>
            </Tooltip>
            {(unitType?.publishedAt || unitType?.isManagedAt) && (
              <Tooltip
                title={
                  <div className="flex flex-col gap-2">
                    {unitType?.publishedAt && (
                      <div className="flex flex-row gap-1 [&>span]:text-neutral-500 [&>span]:font-gilroy-medium">
                        <span>Published at</span>
                        <span>{formatTimestamp(unitType.publishedAt)}</span>
                      </div>
                    )}
                    {unitType?.isManagedAt && (
                      <div className="flex flex-row gap-1 [&>span]:text-neutral-500 [&>span]:font-gilroy-medium">
                        <span>Managed at: </span>
                        <span>{formatTimestamp(unitType.isManagedAt)}</span>
                      </div>
                    )}
                  </div>
                }
              >
                <button
                  type="button"
                  className="flex items-center justify-center size-7 rounded-md border border-gray-200 bg-gray-50 hover:bg-blue-50 hover:border-blue-300 text-gray-400 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  <CalendarIcon size="20px" />
                </button>
              </Tooltip>
            )}
            {unitType && (
              <div className="flex flex-row gap-2">
                <Tooltip
                  title={
                    !unitType.beds || unitType.beds.length === 0
                      ? 'Please make sure beds and Channel Manager Fees are set correctly'
                      : unitType.cmLastModifiedAt
                      ? `Synced ${format(unitType.cmLastModifiedAt)} by ${
                          unitType.cmLastModifiedByUsername
                        } — click to update sync`
                      : 'Sync to Channel Manager'
                  }
                >
                  <button
                    type="button"
                    disabled={
                      !canEditUnitType ||
                      syncingChannelData ||
                      !unitType.beds ||
                      unitType.beds.length === 0
                    }
                    onClick={handleChannelManagerSync}
                    className={`flex items-center justify-center gap-1.5 h-7 px-2 rounded-md border text-base font-medium transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-slate-50 disabled:hover:border-slate-300 disabled:hover:text-slate-500 ${
                      unitType.cmLastModifiedAt
                        ? 'border-sky-500 bg-sky-500 text-white hover:bg-sky-700 hover:border-sky-700'
                        : 'border-slate-300 bg-slate-50 text-slate-600 hover:border-slate-400 hover:bg-slate-100 hover:text-slate-700'
                    }`}
                  >
                    {syncingChannelData ? (
                      <img
                        alt="syncing"
                        src={`${PUBLIC_PATH}/assets/gif/reload.gif`}
                        className="size-4"
                      />
                    ) : unitType.cmLastModifiedAt ? (
                      <ResetIcon size="14px" />
                    ) : (
                      <UnlinkIcon size="18px" />
                    )}
                    <span>{unitType.cmLastModifiedAt ? 'Synced' : 'Sync CM'}</span>
                  </button>
                </Tooltip>

                {unitType.cmLastModifiedAt && (
                  <Tooltip
                    title={`Synced ${format(unitType.cmLastModifiedAt)} by ${
                      unitType.cmLastModifiedByUsername
                    } — click to unSync`}
                  >
                    <button
                      type="button"
                      disabled={
                        !canEditUnitType ||
                        syncingChannelData ||
                        !unitType.beds ||
                        unitType.beds.length === 0
                      }
                      onClick={() => setShowUnsyncedModal(true)}
                      className="flex items-center justify-center gap-1.5 h-7 px-2 rounded-md border text-base font-medium transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed border-slate-300 bg-slate-50 text-slate-600 hover:border-slate-400 hover:bg-slate-100 hover:text-slate-700"
                    >
                      <CloudSyncIcon size="18px" />
                      <span>unSync</span>
                    </button>
                  </Tooltip>
                )}

                {/* Published toggle */}
                <Tooltip
                  title={
                    unitType.isListed
                      ? 'Published — click to unpublish'
                      : 'Not published — click to publish'
                  }
                >
                  <button
                    type="button"
                    disabled={!canEditUnitType || loadingData || disabledListSwitcher}
                    onClick={() =>
                      handleUpdateUnitType({ id: unitType?.id, isListed: !unitType.isListed })
                    }
                    className={`flex items-center justify-center gap-1.5 h-7 px-2 rounded-md border text-base font-medium transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed ${
                      unitType.isListed
                        ? 'border-emerald-600 bg-emerald-600 text-white hover:bg-emerald-700 hover:border-emerald-700'
                        : 'border-slate-300 bg-slate-50 text-slate-600 hover:border-slate-400 hover:bg-slate-100 hover:text-slate-700'
                    }`}
                  >
                    {unitType.isListed ? <EyeIcon size="18px" /> : <EyeOffIcon size="18px" />}
                    <span>{unitType.isListed ? 'Published' : 'Unlisted'}</span>
                  </button>
                </Tooltip>

                {/* Booking mode toggle */}
                <Tooltip
                  title={
                    unitType.bookingMode === BookingMode.INSTANT
                      ? 'Instant Booking — click to switch to Request'
                      : 'Request Booking — click to switch to Instant'
                  }
                >
                  <button
                    type="button"
                    disabled={!canEditUnitType || loadingData || disabledListSwitcher}
                    onClick={() =>
                      handleUpdateUnitType({
                        id: unitType?.id,
                        bookingMode:
                          unitType.bookingMode === BookingMode.INSTANT
                            ? BookingMode.REQUEST
                            : BookingMode.INSTANT
                      })
                    }
                    className={`flex items-center justify-center gap-1.5 h-7 px-2 rounded-md border text-base font-medium transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed ${
                      unitType.bookingMode === BookingMode.INSTANT
                        ? 'border-indigo-300 bg-indigo-100 text-indigo-800 hover:bg-indigo-200 hover:border-indigo-400'
                        : 'border-amber-300 bg-amber-100 text-amber-800 hover:bg-amber-200 hover:border-amber-400'
                    }`}
                  >
                    <BoltIcon size="18px" />
                    <span>
                      {unitType.bookingMode === BookingMode.INSTANT ? 'Instant' : 'Request'}
                    </span>
                  </button>
                </Tooltip>

                {/* Managed toggle */}
                <Tooltip
                  title={
                    unitType.isManaged
                      ? 'Managed — click to unmanage'
                      : 'Not managed — click to manage'
                  }
                >
                  <button
                    type="button"
                    disabled={!canEditUnitType || loadingData || disabledListSwitcher}
                    onClick={() =>
                      handleUpdateUnitType({ id: unitType?.id, isManaged: !unitType.isManaged })
                    }
                    className={`flex items-center justify-center gap-1.5 h-7 px-2 rounded-md border text-base font-medium transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed ${
                      unitType.isManaged
                        ? 'border-emerald-600 bg-emerald-600 text-white hover:bg-emerald-700 hover:border-emerald-700'
                        : 'border-slate-300 bg-slate-50 text-slate-600 hover:border-slate-400 hover:bg-slate-100 hover:text-slate-700'
                    }`}
                  >
                    <ManageIcon size="18px" />
                    <span>{unitType.isManaged ? 'Managed' : 'Unmanaged'}</span>
                  </button>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        <Tabs
          data={{
            tabsList: [
              { component: <></>, key: 'General' },
              { component: <></>, key: 'Assets' },
              { component: <></>, key: 'Pricing' },
              { component: <></>, key: 'Listing Ar' }
            ],
            defaultTab: 'General'
          }}
          style={{ position: TabsPosition.LEFT }}
          eventHandlers={{
            tabChangeHandler: (tabKeyValue) => {
              setTabKey(tabKeyValue);
            }
          }}
        />
        <fieldset
          disabled={!canEditUnitType}
          className="m-0 min-w-0 w-full border-0 p-0"
          onClickCapture={(event) => {
            if (!canEditUnitType) {
              event.preventDefault();
              event.stopPropagation();
            }
          }}
        >
          {tabKey === 'General' && (
            <div className={styles['edit-unit-type-container__wrapper']}>
              <div className="flex flex-col w-full md:flex-row gap-2">
                <EditGeneralInfo
                  data={{
                    unitType,
                    unitTypeGroupsList,
                    unitTypeViewsList,
                    typeOfUnitList,
                    buildingList
                  }}
                  eventHandlers={{
                    submitHandler: (updatedData) => {
                      handleUpdateUnitType(updatedData);
                    }
                  }}
                />
                <div className="flex flex-col md:w-1/2 md:mr-4 md:h-full pl-2">
                  <LandLordInfo
                    data={{
                      landlordName: unitType?.landlordUsername || '',
                      landlordId: unitType?.landlordId || '',
                      landlordEmail: unitType?.landlordEmail || '',
                      landlordPhone: unitType?.landlordPhone || '',
                      landlordShare: unitType?.landlordShare || 0,
                      propertyId: unitType?.propertyId || '',
                      payouts: payouts
                        .filter((p) => p.landlordId === unitType?.landlordId)
                        .map((p) => p.id)
                    }}
                    eventHandlers={{
                      addLandLord: (payoutstoUpdate: string[]) => addLandLord(payoutstoUpdate),
                      updateLandlordShare: (landlordShare: number) =>
                        handleUpdateUnitType({ landlordShare }),
                      deleteLandLord: deleteLandLord
                    }}
                  />
                  <AccountManagerInfo
                    data={{
                      accountManagerName: unitType?.accountManagerName || '',
                      accountManagerId: unitType?.accountManagerId || '',
                      accountManagerEmail: unitType?.accountManagerEmail || '',
                      accountManagerPhone: unitType?.accountManagerPhone || '',
                      propertyId: unitType?.propertyId || ''
                    }}
                    eventHandlers={{
                      addAccountManager: (unitTypeModel: UnitTypeUiModel) => {
                        handleUpdateUnitType(unitTypeModel);
                      },
                      deleteAccountManager: () => {
                        handleUpdateUnitType({
                          accountManagerId: '',
                          accountManagerName: '',
                          accountManagerEmail: '',
                          accountManagerPhone: ''
                        });
                      }
                    }}
                  />
                  <PartnerInfo
                    data={{
                      partnerName: unitType?.partnerUsername || '',
                      partnerId: unitType?.partnerId || '',
                      partnerEmail: unitType?.partnerEmail || '',
                      partnerPhone: unitType?.partnerPhone || '',
                      partnerShare: unitType?.partnerShare || 0,
                      propertyId: unitType?.propertyId || ''
                    }}
                    eventHandlers={{
                      addPartner: addPartner,
                      updatePartnerShare: (partnerShare: number) =>
                        handleUpdateUnitType({ partnerShare }),
                      deletePartner: () => deletePartner()
                    }}
                  />
                  <ManagerInfo
                    data={{
                      propertyManagersList: unitType?.propertyManagersList || [],
                      propertyId: unitType?.id || ''
                    }}
                    eventHandlers={{
                      addPropertyManager: (show) => addPropertyManagement(show),
                      deletePropertyManager: (id: string) => handleDeletePropertyManager(id)
                    }}
                  />
                  <Rooms
                    data={{ units: unitType?.units || [] }}
                    eventHandlers={{
                      submitHandler: (data) => {
                        handleUpdateUnitType({
                          units: unitType?.units?.map((unit) => {
                            if (unit.unitId === data.unitId) {
                              return data;
                            }
                            return unit;
                          })
                        });
                      },
                      submitNewHandler: (data) => {
                        unitType?.units?.push(data);
                        handleUpdateUnitType({
                          units: unitType?.units
                        });
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          {tabKey === 'Assets' && (
            <div className={styles['edit-unit-type-container__wrapper']}>
              <BrandingDetails
                data={{
                  unitTypeId: unitType?.id || '',
                  brandingImage: unitType?.brandingImages || [],
                  submitLoading: syncingChannelData
                }}
                eventHandlers={{
                  uploadBrandingImage: handleUploadBrandingImageClick,
                  deleteBrandingImage: handleDeleteBrandingImageClick
                }}
              />
              {unitType && (
                <EditVisuals
                  data={{
                    roomTypePhotos: unitType?.roomTypePhotos,
                    showRooms: unitType?.showRooms,
                    id: unitType?.id || ''
                  }}
                  eventHandlers={{
                    submitImageHandler: uploadImageHandler,
                    deleteImageHandler: handleDeleteImageHandler,
                    submitShowroomImageHandler: uploadShowRoomImageHandler,
                    deleteShowroomImageHandler: handleDeleteShowroomImageHandler,
                    updateImageOrder: (images) => handleUpdateImageOrder({ roomTypePhotos: images })
                  }}
                />
              )}
              <SelectAmenities
                data={{
                  amenitiesList: amenitiesList || [],
                  selectedAmenities: unitType?.amenities || []
                }}
                config={{ isLoading: loadingAmenities }}
                eventHandlers={{
                  selectAmenity: (amenity) => {
                    if (unitType && unitType.amenities) {
                      handleUpdateUnitType({ amenities: [...unitType.amenities, amenity] });
                    }
                  },
                  unselectAmenity: (amenityId) => {
                    if (unitType && unitType.amenities) {
                      const filteredAmenitiesList = unitType.amenities.filter(
                        (item) => item.id !== amenityId
                      );
                      handleUpdateUnitType({
                        amenities: filteredAmenitiesList
                      });
                    }
                  }
                }}
              />
            </div>
          )}
          {tabKey === 'Pricing' && (
            <div className={styles['edit-unit-type-container__wrapper']}>
              <div className="flex flex-col w-full md:flex-row">
                <EditFinancialInfo
                  data={{
                    unitPrice: unitType?.unitPrice || 0,
                    unitPriceInUSD: unitType?.unitPriceInUSD || 0,
                    minStayDuration: unitType?.minStayDuration || 0,
                    maxStayDuration: unitType?.maxStayDuration || 0,
                    downPayment: unitType?.downPayment || 0,
                    insurance: unitType?.insurance || 0,
                    reservationMode: unitType?.reservationMode || ReservationMode.MONTHLY,
                    currentUnitTypeId: unitType?.id,
                    currentPropertyId: unitType?.propertyId
                  }}
                  config={{
                    userRole,
                    userRoles
                  }}
                  eventHandlers={{
                    submitHandler: (updatedData) => {
                      if (updatedData.reservationMode === ReservationMode.MONTHLY) {
                        updatedData = {
                          ...updatedData,
                          customPrices: []
                        };
                      } else if (updatedData.reservationMode === ReservationMode.DAILY) {
                        updatedData = {
                          ...updatedData,
                          downPayment: 0
                        };
                      }
                      handleUpdateUnitType(updatedData);
                    }
                  }}
                />
                <div className="flex flex-col  rounded-lg bg-white shadow-md md:w-1/2 md:mr-4 md:h-full">
                  {unitType?.reservationMode === 'daily' && (
                    <>
                      <CustomPrice
                        data={{
                          basePrice: unitType.unitPrice || 0,
                          customPrice: unitType?.customPrices || [],
                          currentUnitTypeId: unitType?.id,
                          currentPropertyId: unitType?.propertyId
                        }}
                        config={{
                          userRole,
                          userRoles
                        }}
                        eventHandlers={{
                          updateCustomPrice: (customPrices: CustomPriceModel[]) =>
                            handleUpdateUnitType({ customPrices })
                        }}
                      />

                      <StayDuration
                        data={{
                          stayDuration: (unitType as any)?.stayDuration || []
                        }}
                        eventHandlers={{
                          updateStayDuration: (stayDuration) =>
                            handleUpdateUnitType({ stayDuration })
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
              <EditPlanInfo
                data={{
                  ratePlans: unitType?.ratePlans || [],
                  fees: unitType?.fees || [],
                  reservationMode: unitType?.reservationMode || ReservationMode.MONTHLY,
                  currentUnitTypeId: unitType?.id,
                  currentPropertyId: unitType?.propertyId
                }}
                config={{
                  userRole,
                  userRoles
                }}
                eventHandlers={{
                  submitHandler: (updatedData) => {
                    handleUpdateUnitType(updatedData);
                  }
                }}
              />
            </div>
          )}
          {tabKey === 'Listing Ar' && (
            <div className={styles['edit-unit-type-container__wrapper__row']}>
              <EditGeneralInfoArabic
                data={{ unitType }}
                config={{
                  isLoading: loadingData
                }}
                eventHandlers={{
                  submitHandler: (updatedData) => {
                    handleUpdateUnitType(updatedData);
                  }
                }}
              />
            </div>
          )}
        </fieldset>
      </div>

      {showAssignUserModal && (
        <AssignLandlordModal
          config={{ showModal: showAssignUserModal }}
          eventHandlers={{
            closeHandler: () => {
              setShowAssignUserModal(false);
            },
            chooseUser: (unitTypeModel: UnitTypeUiModel) => {
              unitTypeModel.payoutsToUpdate = payoutstoUpdate;
              handleUpdateUnitType(unitTypeModel);
              setShowAssignUserModal(false);
            }
          }}
        />
      )}

      {showAssignPartnerModal && (
        <AssignPartnerModal
          config={{ showModal: showAssignPartnerModal }}
          eventHandlers={{
            closeHandler: () => {
              setShowAssignPartnerModal(false);
            },
            chooseUser: (unitTypeModel: UnitTypeUiModel) => {
              handleUpdateUnitType(unitTypeModel);
              setShowAssignPartnerModal(false);
            }
          }}
        />
      )}

      {showAssignManagerModal && (
        <AssignManagerModal
          config={{ showModal: showAssignManagerModal }}
          eventHandlers={{
            closeHandler: () => {
              setShowAssignManagerModal(false);
            },
            chooseUser: (user: PropertyUiManagersListModel) => {
              handleAddPropertyManager(user?.id);
              setShowAssignManagerModal(false);
            }
          }}
        />
      )}
      <ConfirmModal
        config={{
          showModal: showUnsyncedModal,
          message: 'Are you sure you want to Unsync Channel Manager?'
        }}
        eventHandlers={{
          denyAction: () => {
            setShowUnsyncedModal(false);
          },
          confirmAction: () => {
            handleUpdateUnitType({
              id: unitType?.id,
              unSyncWithCM: true
            });
            setShowUnsyncedModal(false);
          }
        }}
      />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  userRole: state.auth.role,
  userRoles: state.auth.roles
});

export default connect(mapStateToProps)(EditUnitType);
